<template>
  <EditBadge
    v-if="isEdit"
    @click="$emit('click')"
  >
    <FilterBadgeContent :filter="filter"></FilterBadgeContent>
  </EditBadge>
  <BadgeV02
    label
    outlined
    v-else-if="isDisplayOnly"
  >
    <FilterBadgeContent :filter="filter"></FilterBadgeContent>
  </BadgeV02>
  <DismissibleBadge
    v-else
    @click="$emit('click')"
    @dismiss="$emit('dismiss')"
  >
    <FilterBadgeContent :filter="filter"></FilterBadgeContent>
  </DismissibleBadge>
</template>
<script>
import {
  BadgeV02,
  DismissibleBadge,
} from '@mikmak/components';
import EditBadge from '../EditBadge.vue';
import FilterBadgeContent from './FilterBadgeContent.vue';

export default {
  props: {
    filter: {
      type: Object,
      validator: val => {
        const { key } = val;

        return key !== undefined;
      },
    },
    type: {
      type: String,
      default: 'edit',
    },
  },
  components: {
    BadgeV02,
    DismissibleBadge,
    EditBadge,
    FilterBadgeContent,
  },
  computed: {
    isEdit() {
      return this.type.toLowerCase() === 'edit';
    },
    isDisplayOnly() {
      return this.type.toLowerCase() === 'displayonly';
    },
  },
};
</script>
